import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-darker border-t border-white/5 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-5 gap-12">
        <div className="col-span-1 md:col-span-2">
          <h3 className="text-3xl font-serif text-gold mb-4">Coaching Female.</h3>
          <p className="text-cream/60 font-sans leading-relaxed max-w-sm mb-6 font-light">
            Erhebe Dich in Deine Queen-Energie. Dein Raum für High-End Coaching, spirituelles Wachstum und tiefe Transformation.
          </p>
          <div className="flex gap-4">
            <a href="#" className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-cream/60 hover:text-gold hover:border-gold transition-colors">
              <SafeIcon name="Instagram" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-cream/60 hover:text-gold hover:border-gold transition-colors">
              <SafeIcon name="Facebook" />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-sm font-sans uppercase tracking-widest text-cream mb-6">Expertise</h4>
          <ul className="space-y-4 text-cream/60 font-light">
            <li><Link to="/beziehungsheilung-fuer-frauen" className="hover:text-gold transition-colors">The Love Code</Link></li>
            <li><Link to="/female-leadership-fuer-frauen" className="hover:text-gold transition-colors">The Business Code</Link></li>
            <li><Link to="/programme" className="hover:text-gold transition-colors">Queen Circle</Link></li>
            <li><Link to="/shop" className="hover:text-gold transition-colors">Masterclasses</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-sans uppercase tracking-widest text-cream mb-6">Explore</h4>
          <ul className="space-y-4 text-cream/60 font-light">
            <li><Link to="/about" className="hover:text-gold transition-colors">Über Mich</Link></li>
            <li><Link to="/shop" className="hover:text-gold transition-colors">Boutique</Link></li>
            <li><Link to="/contact" className="hover:text-gold transition-colors">GlücksCall</Link></li>
            <li><Link to="/contact" className="hover:text-gold transition-colors">Kontakt</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-sans uppercase tracking-widest text-cream mb-6">Legal</h4>
          <ul className="space-y-4 text-cream/60 font-light">
            <li><Link to="/impressum" className="hover:text-gold transition-colors">Impressum</Link></li>
            <li><Link to="/datenschutz" className="hover:text-gold transition-colors">Datenschutz</Link></li>
            <li><Link to="/agb" className="hover:text-gold transition-colors">AGB</Link></li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 mt-20 pt-8 border-t border-white/5 text-center text-cream/40 text-sm font-light">
        <p>&copy; {new Date().getFullYear()} Coaching Female. All rights reserved. Designed for Excellence.</p>
      </div>
    </footer>
  );
};

export default Footer;